import React, { useState } from "react";
import BCModal from "../../ui/BCModal";
import LmsTable from "../ui/LmsTable";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";

const CheckNetSuiteForm = ({ checkedLoanDrawBatchId, setCheckedLoanDrawBatchId }) => {
  const myForm = new BCFormController();
  myForm.addCenteredGroup([
    myForm.getComponent(<LmsTable 
      apiSuffix={`accounting/${checkedLoanDrawBatchId}/funded-draws/net-suite-data`}
      isDisabled 
    />)
  ], { blankWidth: 1 });

  return <LmsFormGenerator
    myForm={myForm}
    actions={["close"]}
    handleClose={() => setCheckedLoanDrawBatchId("")}
  />;
};

const VendorsModalTable = ({ loanDrawId }) => {
  return (
    <LmsTable
      title="Vendor"
      apiSuffix={`draws/loan-vendors/${loanDrawId}`}
      actionButtons={["export"]}
      skipClick
      columnLabelsDictionary={{ achcreatedOn: "ACH Created On" }}
    />
  );
};

const FundedDrawsModalTable = ({ clickedLoanDrawBatchId }) => {
  return (
    <LmsTable
      title="Funded Draws"
      apiSuffix={`draws/funded/${clickedLoanDrawBatchId}`}
      actionButtons={["export", "save", "cancel"]}
      onClickModalContent={(_, { clickedRowData }) => <VendorsModalTable loanDrawId={clickedRowData?.id} />}
      onClickModalSize="fullscreen"
      columnClickOptions={{
        loanDraw: {
          idProp: "id",
          isModalContentLink: true,
        }
      }}
      columnLabelsDictionary={{
        bcp: "BCP",
        loanNumber: "Loan #",
        lpamount: "LP Amount",
        je: "JE",
        lppaymentDate: "LP Payment Date",
        lppayment: "LP Payment"
      }}
      calculatedColumns={[
        "budgetDrawAmount", 
        "datedownFee", 
        "inspectionFee", 
        "fundAmount", 
        "wireFee", 
        "totalDrawAmt", 
        "lppayment", 
        "lpamount"
      ]}
    />
  );
};

const LmsAccountingFundedDraws = () => {
  const [checkedLoanDrawBatchId, setCheckedLoanDrawBatchId] = useState("");

  const actionButtons = [
    "export",
    {
      text: "Check NetSuite Data",
      isDisabled: (checkedItems) => checkedItems?.length !== 1,
      handleClick: ({ firstCheckedRow }) => setCheckedLoanDrawBatchId(firstCheckedRow?.id),
      icon: GlobalConstants.Icons.CARET_UP
    }
  ];

  return <>
    {checkedLoanDrawBatchId && <BCModal
      isModalOpen={!!checkedLoanDrawBatchId}
      size="fullscreen"
      closeIcon
      onClose={() => setCheckedLoanDrawBatchId("")}
      content={(
        <CheckNetSuiteForm
          checkedLoanDrawBatchId={checkedLoanDrawBatchId}
          setCheckedLoanDrawBatchId={setCheckedLoanDrawBatchId}
        />
      )}
    />}
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="draws/funded"
      onClickModalContent={(_, { clickedRowData }) => <FundedDrawsModalTable clickedLoanDrawBatchId={clickedRowData?.id} />}
      onClickModalSize="fullscreen"
      columnClickOptions={{
        achanalysis: {
          idProp: "id",
          downloadPath: "draws/ach-analysis",
          downloadHasData: true,
          downloadMethod: "POST",
          downloadPayloadContentType: "JSON",
          downloadFileName: "ACHAnalysis"
        },
        je: {
          idProp: "id",
          isModalContentLink: true,
        }
      }}
      columnLabelsDictionary={{
        lppaymentDate: "LP Payment Date",
        achanalysis: "ACH Analysis",
        je: "JE",
        lpactual: "LP Actual",
        lp1sfunded: "LP Funded (1S)",
        alffunded: "ALF Funded",
        bcifunded: "BCI Funded",
        bcoffunded: "BCOF Funded",
        catfunded: "CAT Funded",
        clsfunded: "CLS Funded",
        cls2funded: "CLS2 Funded",
        copfunded: "COP Funded",
        ncffunded: "NCF Funded",
        pelfunded: "PEL Funded",
        rtifunded: "RTI Funded",
        bcffunded: "BCF Funded",
        bcs1funded: "BCS1 Funded",
        bcf21gafunded: "BCF21 GA Funded",
        bcfbcfunded: "BCFBC Funded",
        bcwbcfunded: "BCWBC Funded",
        bcatfunded: "BCAT Funded",
        lpgfunded: "LP Funded (GA)",
        lpsec1funded: "LP Funded (SEC1)",
        achamountFunded: "ACH Amount Funded"
      }}
    />
  </>;
};

export default LmsAccountingFundedDraws;